// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AutoCompleteDialog_wrapper__vd4MR","dialogList":"AutoCompleteDialog_dialogList__3d_NI"};